import React from 'react';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';

const GridBorderBox = ({ children, isMobile }) => (
  <Box sx={{
    border: '1px solid',
    borderColor: 'gray.A300',
    borderRadius: '8px',
    py: 2,
    px: 3,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: isMobile ? 'column' : 'row',
    gap: 2,
  }}
  >
    {children}
  </Box>
);

GridBorderBox.propTypes = {
  children: PropTypes.node.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export default GridBorderBox;
